import * as React from 'react';
import { getUiConsent, submitConsent } from '@/redux/modules/consent';
import { isTermsOfServiceUnknown, isUserLoggedIn } from '@/redux/modules/user';
import { useDispatch, useSelector } from 'react-redux';
import Button from '@liveauctioneers/caterwaul-components/lib/Button/Button';
import { FormattedMessage } from 'react-intl';
import { getIsWhiteLabel } from '@/redux/modules/whiteLabel';
import Link from '@liveauctioneers/caterwaul-components/lib/Link/Link';
import styled from 'styled-components';
import Throbber from '@liveauctioneers/caterwaul-components/lib/Throbber/Throbber';
import { useLocation } from 'react-router-dom';

const tosLink = (
    <Link rel="noopener" target="_blank" to="/termsandconditions">
        <FormattedMessage id="terms_and_conditions" />
    </Link>
);
const privacyLink = (
    <Link rel="noopener" target="_blank" to="/privacy">
        <FormattedMessage id="privacy_policy" />
    </Link>
);
const cookieLink = (
    <Link rel="noopener" target="_blank" to="/cookie-policy">
        <FormattedMessage id="cookie_policy" />
    </Link>
);

const TermsOfServiceBanner = () => {
    const dispatch = useDispatch();
    const { pathname } = useLocation();
    const userLoggedIn = useSelector(isUserLoggedIn);
    const whiteLabel = useSelector(getIsWhiteLabel);
    const checkout = pathname.includes('/console/');
    const biddingConsole = pathname.includes('/console/');
    const { submitted } = useSelector(getUiConsent);
    const termsOfServiceUnknown = useSelector(isTermsOfServiceUnknown);
    const submit = React.useCallback(() => {
        dispatch(submitConsent(true, 'TermsOfServiceBanner'));
    }, [dispatch]);

    const showTOSBanner = userLoggedIn && termsOfServiceUnknown && !whiteLabel && !checkout && !biddingConsole;

    return showTOSBanner ? (
        <StyledBanner>
            <StyledBannerInner>
                <StyledText>
                    <FormattedMessage id="terms_banner" values={{ cookieLink, privacyLink, tosLink }} />
                </StyledText>
                <div>
                    <StyledSubmitButton onClick={submit} primary red>
                        {!submitted ? <FormattedMessage id="consent.agree" /> : <Throbber colorWhite />}
                    </StyledSubmitButton>
                </div>
            </StyledBannerInner>
        </StyledBanner>
    ) : null;
};

export default TermsOfServiceBanner;

const StyledBanner = styled.div`
    background-color: ${({ theme }) => theme.colors.grey400};
    font-size: 10px;
    display: flex;
    padding: 7px 20px;
    padding: 10px 20px;

    @media (min-width: 374px) {
        font-size: 12px;
    }

    @media (min-width: 768px) {
        font-size: 14px;
    }
`;

const StyledBannerInner = styled.div`
    flex: 1 1 auto;
    justify-content: space-between;
    display: flex;

    @media (min-width: 1240px) {
        margin: 0 auto;
        max-width: 860px;
        padding: 0 0 0 20px;
    }

    & > * {
        @media (min-width: 768px) {
            padding-right: 2em;
        }
    }

    & > a {
        &:hover {
            color: ${({ theme }) => theme.colors.black};
            text-decoration: underline;
        }
    }

    & > span {
        color: ${({ theme }) => theme.colors.grey300};
    }
`;

const StyledText = styled.div`
    margin-top: 0;
    margin-right: 1em;

    @media (min-width: 768px) {
        margin-top: 12px;
    }
`;

const StyledSubmitButton = styled(Button)`
    margin-top: 0;
`;
